import React from 'react'
import { openEvolutionModal, responseData } from 'Pages/AnalyzersV2/@signals'
import { TourOverlay as BaseTourOverlay, default as VirtualTourButton } from 'Pages/Main/Home/VirtualTour'
import { TOUR_STEPS } from './steps'

// Used for back/dot navigation: re-opens evolution modal when jumping into step 12
const openEvolutionForTour = () => {
	if (Object.keys(responseData.value || {}).length > 0) {
		const headers = document.querySelectorAll('table thead th')
		if (headers.length > 1) {
			const clickable = headers[1].querySelector('.MuiBox-root') || headers[1]
			clickable?.click()
		}
	} else {
		openEvolutionModal.value = { demoMode: true }
	}
}

const MODAL_RANGES = [
	{
		from: 12, to: 12,
		open: openEvolutionForTour,
		close: () => { openEvolutionModal.value = {} },
		isOpen: () => Object.keys(openEvolutionModal.value).length > 0
			&& !!document.querySelector('.MuiDialog-paperFullScreen'),
	},
]

export function TourOverlay(props) {
	return <BaseTourOverlay {...props} modalRanges={MODAL_RANGES} />
}

export { TOUR_STEPS }
export default VirtualTourButton
